import React, { useEffect, useState } from "react";
import FilterButtons from "../TemplatesScreen/Templates/filterButtons";
import axios from "axios";
import { useSelector } from "react-redux";
import Carousel from "react-bootstrap/Carousel";
import useWindowSize from "../../hooks/useWindowSize";
import renderCarouselItems from "../TemplatesScreen/Templates/carouselItems";

const GeneratorPageTemplates = ({ type }) => {
  const { lang } = useSelector((state) => ({
    lang: state?.changeLang?.language?.landingPages,
  }));
  const { isDesktop } = useWindowSize();

  const templateTypes = {
    amazon: "E commerce",
    "2d-barcode": "E commerce",
    audio: "MP3",
    booking: "Real Estate",
    calendar: "Event",
    crypto: "Finance and Banking",
    email: "Publishing and Media",
    etsy: "Apps",
    excel: "Learning and Development",
    facebook: "Business",
    file: "PDF",
    "for-payment": "Finance and Banking",
    "google-doc": "Publishing and Media",
    "google-form": "Publishing and Media",
    "google-review": "FeedBack",
    "google-sheet": "Learning and Development",
    "attendance": "Learning and Development",
    image: "Images",
    instagram: "Business",
    link: "Website",
    "link-list": "List Of Links",
    linkedin: "Business",
    map: "Logistics",
    multiurl: "List Of Links",
    "office-365": "Learning and Development",
    paypal: "Finance and Banking",
    pcr: "Medical",
    pdf: "PDF",
    phone: "vCard",
    png: "Images",
    pptx: "Learning and Development",
    reddit: "Business",
    "shape-generator": "Government Services",
    sms: "Business",
    snapchat: "Images",
    "social-media": "Business",
    spotify: "Playlist",
    store: "Apps",
    telegram: "Business",
    text: "CV",
    tiktok: "Business",
    twitter: "Business",
    upi: "Finance and Banking",
    vcard: "vCard",
    venmo: "Business",
    video: "Video",
    whatsapp: "Business",
    "wi-fi": "IT",
    "with-logo": "Business",
    youtube: "Video"
  };
  const templateGeneratorPageBlock = document.getElementById("templateGeneratorPageBlock");
  const [activeId, setActiveId] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [templateTitle, setTemplateTitle] = useState(templateTypes[type] || null);
  useEffect(() => {
    setTemplateTitle(templateTypes[type] || null);
  }, [type]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/entry/constructor/templates");
        const filteredData = response.data.filter((item) => item.pagesSortedByPositionMeQr.some((page) => page.image)).filter((item) => item.title !== "Wi-Fi");
        const transformedData = filteredData.map((item, index) => ({
          id: index + 1,
          title: item.title,
          pages: item.pagesSortedByPositionMeQr
        }));
        setTemplates(transformedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  const locale = useSelector((state) => state.changeLang.change);
  const handleRedirectClick = (pageId) => {
    const localePrefix = locale !== "en" ? `/${locale}` : "";
    const url = `${localePrefix}/entry/constructor/clone/${pageId}`;
  setTimeout(() => {
      window.location.href = url;
    }, 1000);
  };
  const template = templates.find((t) => t.title === templateTitle);
  useEffect(() => {
    if (template) {
      setActiveId(template.id);
    }
  }, [template]);
  if (!template)
    return null;
  return (
    <div>
      { !templateGeneratorPageBlock &&
      <p
    className="fs-3 fw-bold text-center">
        {lang[2]}
      </p>
      }
      <FilterButtons
    originalDivs={templates} action={(id) => {
    const clicked = templates.find((t) => t.id === id);
    if (clicked) {
      setTemplateTitle(clicked.title);
    }
  }} activeId={activeId} />
    <div className="col-lg-10 mx-auto">
      <div key={template.id} className="pb-5">
        <div className="pb-lg-5 pb-3">
          <Carousel interval={null} indicators={isDesktop ? template.pages.length > 4 : template.pages.length > 2} controls={isDesktop ? template.pages.length > 4 : template.pages.length > 2}>
            {isDesktop ? renderCarouselItems(template.pages, 4, handleRedirectClick, type) : renderCarouselItems(template.pages, 2, handleRedirectClick, type)}
          </Carousel>
        </div>
      </div>
    </div>
  </div>
  );
};
export default GeneratorPageTemplates;